<template>
  <div id="app" class="d-flex flex-column vh-100" data-spy="scroll">
    <Flecha />
    <Header />
    <Section>
      <router-view
        @cargar="cargar"
        @cargado="cargado"
        @onError="atraparError"
        @onAlerta="atraparAlerta"
      ></router-view>
    </Section>
    <Footer />
    <b-modal
      id="modalCargando-1"
      v-model="modalCargando"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-header
      size="sm"
    >
      <Cargando color="#000000" :tamanio="200" />
    </b-modal>
    <Modal
      ref="modalError"
      tipoModal="ERROR"
      :mensaje="mensajeError"
      :tituloMensaje="tituloError"
      :ayudaMineduc="ayudaMineduc"
      :recuperarContrasenia="recuperarContrasenia"
      :destino="destino"
    />
    <Modal
      ref="modalAlerta"
      tipoModal="ALERTA"
      :mensaje="mensajeError"
      :tituloMensaje="tituloError"
      :botoneraDoble="botoneraDoble"
      :ayudaMineduc="ayudaMineduc"
      :recuperarContrasenia="recuperarContrasenia"
      :destino="destino"
    />
  </div>
</template>

<script>
import Header from "@/components/wrapper/Header";
import Footer from "@/components/wrapper/Footer";
import Cargando from "@/components/generales//modales/Cargando";
import Section from "@/components/wrapper/Section";
import Modal from "@/components/generales/modales/Mensaje";
import Flecha from "@/components/generales/FlechaArriba";
import { EventBus } from "@/assets/js/EventBus";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Cargando,
    Section,
    Modal,
    Flecha
  },
  data() {
    return {
      modalCargando: false,
      modalError: false,
      modalAlerta: false,
      mensajeError: "",
      tituloError: "",
      botoneraDoble: false,
      recuperarContrasenia: false,
      ayudaMineduc: false,
      etapaProceso: null,
      destino: ""
    };
  },
  watch: {
    //Si cambiamos de pagina, cerramos el mensaje de carga
    $route: function() {
      this.modalCargando = false;
    }
  },
  created() {
    const exist = this.$ss.ttl("jwt");
    if (exist > 0) {
      this.$ss.clear();
    }
  },
  beforeCreate: async function() {
    EventBus.$on("onError", mensaje => {
      this.atraparError(mensaje);
    });
  },
  methods: {
    handleScroll: function() {
      window.scrollY > 0
        ? (document.getElementById("myBtn").style.display = "block")(
            (document.getElementById("flecha-abajo").style.display = "none")
          )
        : (document.getElementById("myBtn").style.display = "none");
      document.getElementById("flecha-abajo").style.display = "none";
    },
    //atrapa error y muestra modal con informacion correspondiente
    atraparError(mensaje, titulo, tipoBotonera, ayuda, codigo) {
      this.tituloError = titulo ? titulo : "Error";
      this.mensajeError = mensaje;
      if (codigo) {
        if (codigo == 700) {
          this.recuperarContrasenia = true;
          this.destino = "OlvidoContrasena";
        }
      }
      this.$refs.modalError.showModal();
    },
    atraparAlerta(mensaje, titulo, tipoBotonera, ayuda, codigo) {
      this.botoneraDoble = false;
      this.ayudaMineduc = false;
      this.tituloError = titulo ? titulo : "Alerta";
      this.mensajeError = mensaje;
      if (tipoBotonera) {
        this.botoneraDoble = true;
      }
      if (ayuda) {
        this.ayudaMineduc = true;
      }
      if (codigo) {
        if (codigo == 503) {
          this.destino = "PostulacionFinalizada";
        }
      }
      this.$refs.modalAlerta.showModal();
    },
    //muestra modal cargando
    cargar() {
      this.modalCargando = true;
    },
    //quita modal de cargando
    cargado() {
      this.modalCargando = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue